import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import HeaderTable from '@/components/platform/copySpeach/HeaderTable.vue';
import TitleCell from '@/components/platform/copySpeach/TitleCell.vue';
import UserCell from '@/components/platform/copySpeach/UserCell.vue';
import Cell from '@/components/platform/copySpeach/Cell.vue';
import SelectCategory from '@/components/platform/copySpeach/SelectCategory.vue';
var SpeachTable = /*#__PURE__*/function (_Vue) {
  function SpeachTable() {
    var _this;
    _classCallCheck(this, SpeachTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpeachTable, [].concat(args));
    _defineProperty(_this, "tableId", void 0);
    _defineProperty(_this, "listSpeach", void 0);
    _defineProperty(_this, "checkedSpeachIds", void 0);
    _defineProperty(_this, "searchable", void 0);
    _defineProperty(_this, "loading", void 0);
    _defineProperty(_this, "platformId", void 0);
    _defineProperty(_this, "headerCheckable", void 0);
    _defineProperty(_this, "checkAllMessage", void 0);
    _defineProperty(_this, "uncheckAllMessage", void 0);
    _defineProperty(_this, "totalOfSpeachesSearch", void 0);
    _defineProperty(_this, "numberOfSpeachesChecked", 0);
    _defineProperty(_this, "tableData", []);
    _defineProperty(_this, "titleFilter", '');
    _defineProperty(_this, "authorFilter", '');
    _defineProperty(_this, "categoryFilter", null);
    return _this;
  }
  _inherits(SpeachTable, _Vue);
  return _createClass(SpeachTable, [{
    key: "mounted",
    value: function mounted() {
      this.onListSpeachChanged();
      this.updateTableRowsChecksState();
    }
  }, {
    key: "onListSpeachChanged",
    value: function onListSpeachChanged() {
      var _this$tableData;
      // We track listSpeach input then update table data (keeping array reference). this avoid el-table to rebuild whole data view on input changes.
      this.tableData.length = 0;
      (_this$tableData = this.tableData).push.apply(_this$tableData, _toConsumableArray(this.listSpeach));
    }
  }, {
    key: "onCheckedSpeachChanged",
    value: function onCheckedSpeachChanged() {
      this.updateTableRowsChecksState();
    }
  }, {
    key: "onCategoryUpdated",
    value: function onCategoryUpdated(category) {
      this.categoryFilter = category;
      this.$emit('filterCategory', this.categoryFilter);
    }
  }, {
    key: "onTitleFilterUpdated",
    value: function onTitleFilterUpdated(title) {
      this.titleFilter = title;
      this.$emit('filterTitle', this.titleFilter);
    }
  }, {
    key: "onAuthorFilterUpdated",
    value: function onAuthorFilterUpdated(author) {
      this.authorFilter = author;
      this.$emit('filterAuthor', this.authorFilter);
    }
  }, {
    key: "rowChecked",
    value: function rowChecked(checkedList, row) {
      this.numberOfSpeachesChecked = checkedList.length;
      this.$emit('check', checkedList, row);
    }
  }, {
    key: "allChecked",
    value: function allChecked(checkedList) {
      this.numberOfSpeachesChecked = checkedList.length;
      this.$emit('all-check', checkedList);
    }
  }, {
    key: "selectAllFromBack",
    value: function selectAllFromBack() {
      this.$emit('select-all-from-back');
    }
  }, {
    key: "clearAllFromBack",
    value: function clearAllFromBack() {
      this.$emit('clear-all-from-back');
    }
  }, {
    key: "visibilityChanged",
    value: function visibilityChanged(isVisible, row) {
      if (isVisible && !(row !== null && row !== void 0 && row.title)) {
        this.$emit('empty-cour-visible', row);
      }
    }
  }, {
    key: "updateTableRowsChecksState",
    value: function updateTableRowsChecksState() {
      var _this2 = this;
      var speachTableRef = this.$refs[this.tableId];
      if (speachTableRef) {
        var _this$checkedSpeachId;
        if ((_this$checkedSpeachId = this.checkedSpeachIds) !== null && _this$checkedSpeachId !== void 0 && _this$checkedSpeachId.length) {
          this.tableData.forEach(function (row) {
            if (_this2.checkedSpeachIds.includes(row.speachID)) {
              speachTableRef.toggleRowSelection(row, true);
            } else {
              speachTableRef.toggleRowSelection(row, false);
            }
          });
        } else {
          speachTableRef.clearSelection();
        }
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], SpeachTable.prototype, "tableId", void 0);
__decorate([Prop({
  default: []
})], SpeachTable.prototype, "listSpeach", void 0);
__decorate([Prop({
  default: function _default() {
    return [];
  }
})], SpeachTable.prototype, "checkedSpeachIds", void 0);
__decorate([Prop({
  default: false,
  type: Boolean
})], SpeachTable.prototype, "searchable", void 0);
__decorate([Prop({
  default: false
})], SpeachTable.prototype, "loading", void 0);
__decorate([Prop({
  default: ''
})], SpeachTable.prototype, "platformId", void 0);
__decorate([Prop({
  default: false
})], SpeachTable.prototype, "headerCheckable", void 0);
__decorate([Prop({
  default: false
})], SpeachTable.prototype, "checkAllMessage", void 0);
__decorate([Prop({
  default: false
})], SpeachTable.prototype, "uncheckAllMessage", void 0);
__decorate([Prop({
  default: 0
})], SpeachTable.prototype, "totalOfSpeachesSearch", void 0);
__decorate([Watch('listSpeach')], SpeachTable.prototype, "onListSpeachChanged", null);
__decorate([Watch('checkedSpeachIds')], SpeachTable.prototype, "onCheckedSpeachChanged", null);
SpeachTable = __decorate([Options({
  components: {
    SelectCategory: SelectCategory,
    UserCell: UserCell,
    Cell: Cell,
    TitleCell: TitleCell,
    HeaderTable: HeaderTable
  },
  emits: ['filterTitle', 'filterAuthor', 'filterCategory', 'check', 'all-check', 'select-all-from-back', 'clear-all-from-back', 'empty-cour-visible']
})], SpeachTable);
export default SpeachTable;